// Edit this file to change branding, contact details, navigation and section copy.
export const SITE = {
  brand: "OURUMDIGITAL",
  brandParts: ["OURUM", "DIGITAL"],
  tagline: "Websites, AI automation, social media and SEO",
  hero: {
    headline: ["Websites, AI agents", "& social growth", "that move business."],
    description:
      "We design websites and landing pages, automate customer chats with AI, and grow brands on Instagram and Google.",
  },
  about: {
    title: "A passionate team of digital creators and problem solvers.",
    body: [
      "With creativity, strategy and technology, we help businesses grow rapidly through smart digital solutions.",
    ],
    // [EDIT] Add founder / team details here when ready, e.g. "Founded by ..."
    extra: "",
  },
  skills: [
    "Content & Copy Writing",
    "AI Automation",
    "SEO & SEM",
    "Social Media Advertising",
    "Video Editing",
    "Web & Landing Page Design",
    "Graphic Design",
    "Digital Marketing",
  ],
  services: [
    { name: "Website Development", desc: "Responsive, modern websites and landing pages that convert visitors into customers.", color: "#2A48B0", icon: "Monitor" },
    { name: "AI Agents Automation", desc: "Automate workflows and build AI agents to save time, reduce costs and boost productivity.", color: "#4D6B1F", icon: "Bot" },
    { name: "Social Media Management", desc: "Profile optimisation, content strategy, growth, analytics and creator collaborations.", color: "#5B3FA6", icon: "Instagram" },
    { name: "Digital Marketing & SEO", desc: "Plan and execute digital marketing on every viable platform, plus local and brand keyword SEO.", color: "#B14A1C", icon: "Search" },
    { name: "Content Creating", desc: "Write content and design visuals for promotional articles, ads, social media and website SEO.", color: "#A83A4C", icon: "PenTool" },
  ],
  // [EDIT] Process wording is fully editable.
  process: [
    { name: "Discovery", desc: "We learn about your business, your customers and what you want to achieve." },
    { name: "Planning", desc: "We map the strategy, structure and content for your website, automation or campaign." },
    { name: "Creation", desc: "We design, build and write, sharing progress so you can give feedback early." },
    { name: "Delivery", desc: "We launch, hand over and keep improving based on real results." },
  ],
  contact: {
    email: "ourumdigital@gmail.com",
    phone: "+91 6398062885",
    whatsapp: "916398062885",
  },
  // [EDIT] Paste full profile URLs. Empty links are hidden automatically.
  socials: { instagram: "", linkedin: "", facebook: "", x: "" },
  nav: [
    { label: "Work", href: "#work" },
    { label: "About", href: "#about" },
    { label: "Services", href: "#services" },
    { label: "Process", href: "#process" },
    { label: "Contact", href: "#contact" },
  ],
};
